module.exports = __webpack_public_path__ + "static/media/227-senegal.1da1c2fb.svg";